import { render, staticRenderFns } from "./Risk.vue?vue&type=template&id=0f77b889&scoped=true"
var script = {}
import style0 from "./Risk.vue?vue&type=style&index=0&id=0f77b889&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f77b889",
  null
  
)

export default component.exports